import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateRoomDataCache, resolveClientId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const getRooms = async (clientId?: number, search?: string) => {
    try {
        const params = new URLSearchParams();
        if (typeof clientId === "number") {
            params.set("clientId", String(clientId));
        }
        if (typeof search === "string") {
            params.set("searchStr", search);
        }
        const query = params.toString();
        const response = await axiosInstance.get(
            `/room/getAll${query ? `?${query}` : ""}`
        );

        return response.data;
    } catch (error) {
        console.log("Error getting rooms", error);
    }
};

const addRoom = async (payload: {
    accountId: number;
    name: string;
    clientId: number;
}) => {
    try {
        const scopedAccountId = getScopedAccountId(payload.accountId);
        const response = await axiosInstance.post(`/room/add?accountId=${scopedAccountId}`, {
            ...payload,
            accountId: scopedAccountId,
        });
        if (isMutationSuccess(response.data)) {
            invalidateRoomDataCache(resolveClientId(payload, response.data));
        }
        return response.data;
    } catch (error) {
        console.log("Error adding room", error);
        const responseData = (error as any)?.response?.data;
        if (responseData) {
            return responseData;
        }

        return {
            error: true,
            message: "Failed to add room. Please try again.",
        };
    }
};

export { getRooms, addRoom };
